import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { groupColDefs, gridOptions, getEndpointDataByTenantId } from './groups-constants';
import { styles } from './groups-styles';
import { BreadCrumbsComponent } from '../../components/breadcrumbs/breadcrumbsComponent';
import { Box } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import { SubHeader } from '../organizations/subheader';
import { DataGrid } from '../../components/data-grid/data-grid';
const Groups = (props)=>{
    const classes = styles();
    const { navigate, onSelection, viewOnly, selectedOrg, sortablePageable } = props;
    const [pageSize, setPageSize] = useState(25);
    const handleAddGroup = ()=>{
        if (navigate) {
            const path = window.location.pathname;
            navigate(path + `/add`);
        }
    };
    const handleSelection = (item)=>{
        const path = window.location.pathname;
        onSelection({
            data: item,
            path: path + `/group/${item.id}`
        });
    };
    const onPageSizeChange = (pageSize)=>{
        setPageSize(pageSize);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(BreadCrumbsComponent, {}),
            /*#__PURE__*/ _jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                flex: "1 1 0",
                minHeight: 0,
                children: [
                    /*#__PURE__*/ _jsx(SubHeader, {
                        title: 'Groups',
                        className: classes.text,
                        actionName: viewOnly ? '' : 'Add Group',
                        onActionClick: handleAddGroup,
                        pageSize: pageSize,
                        onPageSizeChange: onPageSizeChange
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        paddingTop: 5,
                        flex: "1 1 0",
                        minHeight: 0,
                        display: "flex",
                        flexDirection: "column",
                        children: /*#__PURE__*/ _jsx(DataGrid, {
                            columnDefs: groupColDefs,
                            gridOptions: gridOptions,
                            endpointData: getEndpointDataByTenantId(selectedOrg.tenantId),
                            serverSideInfiniteScroll: true,
                            filterableOptions: sortablePageable.filterableOptions,
                            onRowClicked: (item)=>{
                                handleSelection(item?.data);
                            },
                            paginationPageSize: pageSize
                        })
                    })
                ]
            })
        ]
    });
};
Groups.displayName = 'Groups';
export { Groups };
